import { FC } from "react"

import { ListSkeleton } from "../../../skeletons"
import Table from "../../../table"
import NoData from "../../../no-data"
import { useFetchLeadListQuery } from "../../../../../redux/queries"
import { getLeadListColumns } from "./columns"
import { BBColumnDef, LeadLogStat } from "../../../../../types"

interface LeadListProps {
  title: string
  range: number
  orgId?: string
  loid?: string
}

const LeadList: FC<LeadListProps> = ({ title, range, orgId, loid }) => {
  const leadListColumns: BBColumnDef<LeadLogStat>[] = getLeadListColumns()
  const { data, isFetching } = useFetchLeadListQuery(
    {
      range,
      org_id: orgId,
      loid
    },
    { refetchOnMountOrArgChange: true }
  )
  const leadListData = data ?? []

  return (
    <div className="bg-white flex flex-col flex-1 p-6 rounded-md overflow-hidden">
      <div className="flex flex-col md:flex-row items-center justify-between mb-6 md:mb-8">
        <div className="w-full md:w-auto font-medium">{title}</div>
      </div>
      <div className="flex flex-col">
        <Table
          isLoading={isFetching}
          data={leadListData}
          columns={leadListColumns}
          viewType="table"
          pageSize={leadListData.length}
          tableContainerClassName={
            leadListData.length > 0 ? "h-[700px]" : "h-[380px]"
          }
          tableClassName="md:table-fixed"
          extraHeaderElementClassName="w-full md:w-auto md:ml-auto"
          loaderSkeleton={
            <ListSkeleton noOfRows={4} containerClassName="px-6 pt-4 pb-8" />
          }
          noDataElement={
            <td colSpan={6}>
              <div className="flex w-full h-[210px]">
                <NoData />
              </div>
            </td>
          }
          searchBarVisible={false}
        />
      </div>
    </div>
  )
}

export default LeadList
